module.exports = __webpack_public_path__ + "static/conditional_format2-5afa3bb7ae5b783002a9f85a9e311341.jpg";